import { Zap, Leaf } from 'lucide-react';

function BannerContent() {
  return (
    <span className="inline-flex items-center gap-3 whitespace-nowrap px-12">
      <Zap className="w-4 h-4 flex-shrink-0" />
      <Leaf className="w-4 h-4 flex-shrink-0" />
      <span className="font-bold">"A Fully Electric Fleet. A Fully Backed Rider."</span>
      <span className="mx-4 w-px h-4 bg-white/50 inline-block" />
      <span>
        Drop24 has completed its transition to{' '}
        <span className="font-bold underline">100% electric</span>
        {" — we're going green."}
      </span>
    </span>
  );
}

export default function TopBanner() {
  return (
    <div
      className="fixed top-0 left-0 right-0 bg-[#0f8a4c] text-white text-sm overflow-hidden z-[60]"
      data-testid="top-banner"
      style={{ height: '36px', lineHeight: '36px' }}
    >
      <div className="animate-marquee flex items-center h-full">
        <BannerContent />
        <BannerContent />
        <BannerContent />
        <BannerContent />
      </div>
    </div>
  );
}
